import Entities from './shared/Entities';

export default class ToggleContainer {
    constructor() {
        this.entities = new Entities(
            'ToggleContainer',
            '[data-toggle-container]',
            ToggleContainer.initSingle,
            ToggleContainer.destroySingle,
        );
    }

    static initSingle(containerEl) { 
        const buttons = containerEl.querySelectorAll('[data-toggle-container-button]');
        const containers = containerEl.querySelectorAll('[data-toggle-container-element]');
        const insideElements = containerEl.querySelectorAll('[data-toggle-container-inside-element]');

        if (!buttons.length) return;

        const setActive = (value) => {
            buttons.forEach(btn => {
                const attr = btn.getAttribute('data-toggle-container-button');
                if (attr === value) {
                    btn.setAttribute('data-active', '');
                } else {
                    btn.removeAttribute('data-active');
                }
            });

            containers.forEach(el => {
                const attr = el.getAttribute('data-toggle-container-element');
                if (attr === value) {
                    el.setAttribute('data-active', '');
                } else {
                    el.removeAttribute('data-active');
                }
            });

            insideElements.forEach(el => {
                const attr = el.getAttribute('data-toggle-container-inside-element') || '';
                
                const values = attr.split(',').map(v => v.trim());

                if (values.includes(value)) {
                    el.setAttribute('data-active', '');
                } else {
                    el.removeAttribute('data-active');
                }
            });
        };

        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
                const value = btn.getAttribute('data-toggle-container-button');
                setActive(value);
            });
        });

        const firstValue = buttons[0].getAttribute('data-toggle-container-button');
        setActive(firstValue);
    }

    static destroySingle({ entityObj }) {
        entityObj?.destroy();
    }
}